import React, { useEffect, useState } from 'react';
import AuthContext from '../../contexts/AuthContext';

interface AccessEventDetail {
  access_mode?: string;
  required?: string;
  status?: number;
}

const AccessDeniedModal: React.FC = () => {
  const { startTrial } = React.useContext(AuthContext);
  const [visible, setVisible] = useState(false);
  const [detail, setDetail] = useState<AccessEventDetail>({});

  useEffect(() => {
    const handler = (event: Event) => {
      const custom = event as CustomEvent<AccessEventDetail>;
      setDetail(custom.detail || {});
      setVisible(true);
    };
    window.addEventListener('access_denied', handler as EventListener);
    return () => window.removeEventListener('access_denied', handler as EventListener);
  }, []);

  if (!visible) return null;

  const mode = detail.access_mode || 'inconnu';
  const isTrialCandidate = mode === 'preview' || mode === 'read_only';

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Accès limité</h3>
        <p className="text-sm text-gray-700 mb-4">
          Cette action n&apos;est pas autorisée en mode <strong>{mode}</strong>
          {detail.required ? ` (requis : ${detail.required})` : ''}.
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => setVisible(false)}
            className="px-3 py-2 text-sm border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Fermer
          </button>
          {isTrialCandidate && (
            <button
              onClick={async () => {
                try {
                  await startTrial();
                } catch (err) {
                  console.error('Impossible de démarrer l’essai', err);
                } finally {
                  setVisible(false);
                }
              }}
              className="px-3 py-2 text-sm bg-primary-600 text-white rounded-md hover:bg-primary-700"
            >
              Démarrer l’essai 7 jours
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedModal;
